import "./ScrollSuggestion.scss";

import { motion } from "framer-motion";
import Lottie from "lottie-react";
import React from "react";

import Scroll from "../../../Assets/Lotties/ScrollSuggestion.json";

export const ScrollSuggestion: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0, 1, 1, 0] }}
      transition={{ duration: 15, times: [0, 0.4, 0.5, 0.95, 1] }}
    >
      <Lottie
        className="lottie"
        animationData={Scroll}
        loop={true}
        style={{ height: "5rem", opacity: 0.25 }}
      />
    </motion.div>
  );
};
